import { useEffect, useState } from "react";
import { api } from "./api";
import { LOCATIONS } from "./data";

/**
 * useCityAreas — fetch nearby areas for a given city from the backend.
 * Falls back to the static LOCATIONS seed on network / empty response so the
 * UI always has something to show.
 */
export default function useCityAreas(city) {
  const [areas, setAreas] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    if (!city) { setAreas([]); return; }
    setLoading(true);
    api.get(`/locations/areas?city=${encodeURIComponent(city)}`)
      .then((r) => {
        if (cancelled) return;
        const list = (r.data && Array.isArray(r.data.areas)) ? r.data.areas : [];
        setAreas(list.length ? list : (LOCATIONS[city] || []));
      })
      .catch(() => { if (!cancelled) setAreas(LOCATIONS[city] || []); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [city]);

  return { areas, loading };
}
